export class LocationServiceMockSpec {
    getSearch() {}
}
